import { ROUTES } from 'Utils/constants'

export const CUSTOMER_DISPLAY_SUPPORTED_ROUTES = [
  ROUTES.createQuote,
  ROUTES.editQuoteHeaderId,
  ROUTES.generateQuote,
  ROUTES.quoteProduct,
]

// Routes that should reset the Customer Display to idle state
const CUSTOMER_DISPLAY_RESET_ROUTES = [ROUTES.quoteProduct, ROUTES.createQuote]

export const isCustomerDisplayRouteSupported = pathname =>
  CUSTOMER_DISPLAY_SUPPORTED_ROUTES.some(route => pathname.includes(route))

export const shouldResetCustomerDisplayView = (prevPathname, nextPathname) => {
  if (!prevPathname || prevPathname === nextPathname) return false

  // Reset when navigating to an unsupported route
  if (!isCustomerDisplayRouteSupported(nextPathname)) {
    return true
  }

  // Reset when navigating to specific reset routes
  const navigatedToResetRoute = CUSTOMER_DISPLAY_RESET_ROUTES.some(
    route => nextPathname.includes(route) && !prevPathname.includes(route)
  )

  return navigatedToResetRoute
}
